import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

// Types
import type { Props } from '@/components/ui/Title'

// Props
import useThemeClassName from '@/hooks/useThemeClassName'

// Computed

export default /*#__PURE__*/_defineComponent({
  __name: 'Title',
  props: {
    theme: {},
    type: { default: "h2" }
  },
  setup(__props: any) {

const props = __props;

// Use
const themeClassName = computed(() => useThemeClassName('ui-title', props.theme))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type), _mergeProps({ class: "ui-title" }, _ctx.$attrs, {
    class: [themeClassName.value]
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})